import { render, staticRenderFns } from "./InstitutionMicrosoftConfiguration.vue?vue&type=template&id=3349487d&scoped=true&"
import script from "./InstitutionMicrosoftConfiguration.vue?vue&type=script&lang=js&"
export * from "./InstitutionMicrosoftConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./InstitutionMicrosoftConfiguration.vue?vue&type=style&index=0&id=3349487d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3349487d",
  null
  
)

export default component.exports